// CORE-1735 slice 19 (D-132) — Live icon «moon»: the header's switch to the dark theme.
// Hand-drawn 24-grid crescent (filled); colour from the caller.
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Moon: React.FC<LiveGlyphProps> = ({ size, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Path d="M20.5 14.3A8.6 8.6 0 0 1 9.7 3.5a8.6 8.6 0 1 0 10.8 10.8Z" fill={color} />
  </Svg>
);
